const ChatMode = {
    Windowed: 1,
    DOM: 2
};
export default ChatMode;
